import { classNames, twMerge } from '@panwds/tailwindcss';
export const subNavListV3Classes = {
    root: {
        base: 'twds-flex twds-flex-col',
        dimensions: 'twds-h-7'
    },
    button: {
        base: {
            group: 'twds-group',
            flex: 'twds-flex twds-items-center',
            font: 'twds-font-lato',
            dimensions: 'twds-h-7',
            spacing: 'twds-mx-2 twds-pr-1 twds-py-0 twds-my-[1px]',
            boxSizing: 'twds-box-border',
            text: 'twds-text-xs',
            textHover: 'hover:twds-text-steel-gray-100',
            textActive: 'active:twds-text-steel-gray-100',
            cursor: 'twds-cursor-pointer',
            background: 'twds-bg-transparent dark:twds-bg-transparent twds-transition-all twds-duration-200 twds-ease-in-out',
            hover: 'hover:twds-bg-steel-gray-800 dark:hover:twds-bg-steel-gray-800',
            active: 'active:twds-bg-steel-gray-600',
            border: 'twds-rounded twds-border-solid twds-border-b-0 twds-border-t-0 twds-border-r-0 twds-border-l-0'
        },
        match: {
            text: 'twds-text-steel-gray-400'
        },
        borderLeftTransparent: 'twds-border-l-transparent dark:twds-border-l-transparent',
        noneMatched: {
            background: 'twds-bg-steel-gray-700 dark:twds-bg-steel-gray-700',
            text: 'twds-text-steel-gray-100',
            border: 'twds-border-l-blue-400 dark:twds-border-l-blue-400'
        },
        childrenAndMatch: {
            border: 'twds-border-blue-steel-900 dark:twds-border-black hover:twds-border-blue-steel-800 dark:hover:twds-border-blue-steel-800'
        },
        noBorderTop: 'twds-border-t-0',
        isSelected: {
            text: 'twds-text-steel-gray-100',
            background: 'twds-bg-steel-gray-700 dark:twds-bg-steel-gray-700'
        },
        caretRightIcon: 'twds-absolute twds-left-11 twds-transition-opacity twds-duration-150',
        action: {
            flex: 'twds-flex twds-items-center twds-justify-center',
            border: 'twds-rounded',
            display: 'twds-hidden group-hover:twds-flex',
            transform: 'twds-scale-0  group-hover:twds-scale-100',
            transition: 'twds-transition-all twds-duration-200 twds-ease-in-out twds-origin-center',
            background: 'hover:twds-bg-steel-gray-850 active:twds-bg-steel-gray-700'
        },
        actionWrap: 'twds-flex twds-items-center',
        titleWrap: 'twds-truncate twds-mr-2',
        actionsContainer: {
            flex: 'twds-flex twds-justify-between twds-items-center',
            dimensions: 'twds-w-full twds-h-5',
            spacing: 'twds-py-[3px]'
        },
        disabled: 'twds-opacity-60 twds-cursor-not-allowed'
    },
    title: {
        flex: 'twds-flex',
        box: 'twds-box-border',
        overflow: 'twds-truncate',
        spacing: 'twds-pl-4 twds-my-2',
        font: 'twds-font-lato twds-font-semibold',
        text: 'twds-text-2xs twds-text-steel-gray-200 twds-uppercase'
    },
    list: {
        overflow: 'twds-overflow-auto',
        spacing: 'twds-m-0 twds-p-0',
        boxSizing: 'twds-box-border',
        style: 'twds-list-none',
        border: 'twds-b-0'
    },
    divider: {
        height: 'twds-h-[1px]',
        background: 'twds-bg-steel-gray-700',
        spacing: 'twds-ml-1 twds-mr-[5px] twds-mt-2'
    }
};
export function getSubNavListRootClasses() {
    return classNames(subNavListV3Classes.root.base
    // subNavListV3Classes.root.dimensions
    // isHeading && 'twds-h-8'
    );
}
export function getSubNavListClasses() {
    return classNames(subNavListV3Classes.list.overflow, subNavListV3Classes.list.spacing, subNavListV3Classes.list.boxSizing, subNavListV3Classes.list.style, subNavListV3Classes.list.border);
}
function getButtonBaseClasses(disabled) {
    return classNames(subNavListV3Classes.button.base.flex, subNavListV3Classes.button.base.boxSizing, subNavListV3Classes.button.base.spacing, subNavListV3Classes.button.base.cursor, subNavListV3Classes.button.base.background, !disabled && subNavListV3Classes.button.base.hover, !disabled && subNavListV3Classes.button.base.active, subNavListV3Classes.button.base.border, subNavListV3Classes.button.base.dimensions, subNavListV3Classes.button.base.font, subNavListV3Classes.button.base.text, !disabled && subNavListV3Classes.button.base.textHover, !disabled && subNavListV3Classes.button.base.textActive, subNavListV3Classes.button.base.group);
}
function getButtonNoneMatchClasses() {
    return classNames(subNavListV3Classes.button.noneMatched.background, subNavListV3Classes.button.noneMatched.border, subNavListV3Classes.button.noneMatched.text);
}
function getHasChildrenAndMatchClasses() {
    return classNames(subNavListV3Classes.button.childrenAndMatch.border
    //subNavListV3Classes.button.childrenAndMatch.background
    );
}
export function getSubNavListActionClasses(isButton) {
    return classNames(
    // SubNavListV3Classes.button.action.display,
    subNavListV3Classes.button.action.transform, subNavListV3Classes.button.action.transition, subNavListV3Classes.button.action.background, subNavListV3Classes.button.action.border, subNavListV3Classes.button.action.flex, isButton && 'twds-w-5 twds-h-5');
}
export function getSubNavListTitleClasses(className) {
    return classNames(subNavListV3Classes.title.font, subNavListV3Classes.title.overflow, subNavListV3Classes.title.spacing, subNavListV3Classes.title.text, subNavListV3Classes.title.flex, subNavListV3Classes.title.box, className);
}
export function getSubNavListActionsContainerClasses() {
    return classNames(subNavListV3Classes.button.actionsContainer.flex, subNavListV3Classes.button.actionsContainer.dimensions, subNavListV3Classes.button.actionsContainer.spacing);
}
export function getSubNavListButtonClasses(match, nonParentMatch, className, disabled) {
    return twMerge(getButtonBaseClasses(disabled), !match && subNavListV3Classes.button.match.text, nonParentMatch ? getButtonNoneMatchClasses() : getHasChildrenAndMatchClasses(), subNavListV3Classes.button.borderLeftTransparent, subNavListV3Classes.button.noBorderTop, disabled && subNavListV3Classes.button.disabled, 'twds-pl-2', className);
}
export function getSubNavListCaretRightIconClasses(collapsed) {
    return classNames(subNavListV3Classes.button.caretRightIcon, collapsed ? 'twds-opacity-100' : 'twds-opacity-0');
}
export function getSubNavListActionWrapClasses(primaryIcon, secondaryIcon) {
    return classNames(subNavListV3Classes.button.actionWrap, primaryIcon && secondaryIcon && 'twds-gap-[1px]');
}
export function getSubNavDividerClasses() {
    return classNames(subNavListV3Classes.divider.height, subNavListV3Classes.divider.background, subNavListV3Classes.divider.spacing);
}
//# sourceMappingURL=subNavListItem.logic.js.map